module.exports = __webpack_public_path__ + "img/fan-table.d28b477f.svg";